/**
 * Ends the working session because the screen was left idle (SEC-014). In this order, and each step matters:
 * the lock flag first (so a reload cannot slip back in), renewal stopped (the provider's idle clock must run),
 * the token revoked on the server (a copy of it is dead, SEC-016), then the token dropped from this page and the
 * shell told, which removes every record from the screen.
 */
import { api, SESSION_ENDED, setToken } from "./api.js";
import { markLocked } from "./idle-lock.js";
import { sessionRefresher } from "./session.js";

export async function lockSession(): Promise<void> {
  markLocked(sessionStorage);
  sessionRefresher.stop();
  // best effort: with no connection the token simply runs out within its five-minute life
  await api.post("/api/v1/me/logout").catch(() => undefined);
  setToken(null);
  window.dispatchEvent(new Event(SESSION_ENDED));
}
